import { DisplayAreaContentsInfo } from '@wconcept/wconcept-common/models/display/display';
import { BrandInfo } from '@wconcept/wconcept-common/models/renewal/brand';
import { DisplayContentInfo } from '@wconcept/wconcept-common/models/renewal/display';
import { MyHeartBrandInfo } from '@wconcept/wconcept-common/models/renewal/myHeart';
import { Product } from '@wconcept/wconcept-common/models/renewal/product';
import { useCallback } from 'react';
import { Brand } from '@components/pages/shopPilot/types';
import useGlobalState from './useGlobalState';

function useAppsFlyerEvent() {
  const { pageInfo, appInfo, isMobile, domainGender, assistData } =
    useGlobalState();

  interface AppsFlyerEventParams {
    af_content_type: string;
    af_brand_code: number;
    af_cust_no: string;
    af_category_depth_1?: string;
    af_category_depth_2?: string;
    af_category_depth_3?: string;
    af_item_code?: string;
    af_content_id?: string;
  }

  const sendAppsFlyerEvent = useCallback(
    (eventName: string, eventValue: AppsFlyerEventParams) => {
      if (window.AF) {
        window.AF('pba', 'event', {
          eventType: 'EVENT',
          eventValue,
          eventName,
        });
      }
    },
    []
  );

  const sendAppsFlyerMyHeartBrand = useCallback(
    ({
      value,
      heratYn,
    }: {
      value?:
        | DisplayAreaContentsInfo
        | BrandInfo
        | DisplayContentInfo
        | MyHeartBrandInfo
        | Brand;
      heratYn?: boolean;
    }) => {
      // 마이하트 추가할때만 appsflyer 이벤트 전송 (공통정책)
      if (!heratYn) return;
      sendAppsFlyerEvent('my_heart_brand', {
        af_content_type: 'EVENT',
        af_brand_code: Number(value?.brandCd) || 0,
        af_cust_no: assistData?.user?.userNo || '0',
      });
    },
    [assistData?.user?.userNo, sendAppsFlyerEvent]
  );

  const sendAppsFlyerMyHeartProduct = useCallback(
    ({ product, heratYn }: { product?: Product; heratYn?: boolean }) => {
      // 마이하트 추가할때만 appsflyer 이벤트 전송 (공통정책)
      if (!heratYn) return;
      sendAppsFlyerEvent('my_heart_item', {
        af_content_type: 'EVENT',
        af_brand_code: product?.brandCd || 0,
        af_cust_no: assistData?.user?.userNo || '0',
        af_category_depth_1: product?.categoryDepthName1,
        af_category_depth_2: product?.categoryDepthName2,
        af_category_depth_3: product?.categoryDepthName3,
        af_item_code: product?.itemCd,
        af_content_id: product?.itemCd,
      });
    },
    [assistData?.user?.userNo, sendAppsFlyerEvent]
  );

  return {
    sendAppsFlyerEvent,
    sendAppsFlyerMyHeartBrand,
    sendAppsFlyerMyHeartProduct,
  };
}

export default useAppsFlyerEvent;
